import { render, staticRenderFns } from "./GamePendingApprovalOnPage.vue?vue&type=template&id=87472536"
import script from "./GamePendingApprovalOnPage.vue?vue&type=script&lang=js"
export * from "./GamePendingApprovalOnPage.vue?vue&type=script&lang=js"
import style0 from "./GamePendingApprovalOnPage.vue?vue&type=style&index=0&id=87472536&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports